import React from 'react';
import { SectionHeader } from './SectionHeader';
import { JumbotronTypes } from '../../../../homePage/components/jumbotron';

export const BackgroundHero = ({
  media,
  locationMapConfig,
  headHeight,
  variant,
  sectionHeader,
  setShowModalMapLocation,
}: JumbotronTypes.IBackgroundHeroSection) => {
  const renderImage = () => {
    let image = media?.url;

    return (
      <div
        style={{
          backgroundImage: `linear-gradient(
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.3)
  ), url(${image})`,
          height: headHeight,
        }}
        className="BackgroundImage"
      >
        <SectionHeader
          {...sectionHeader}
          setShowModalMapLocation={setShowModalMapLocation}
          locationMapConfig={locationMapConfig}
        />
      </div>
    );
  };

  return (
    <div
      className={`${
        variant === 'multiLocationListOfCard'
          ? 'ViewRatesjumbotronHalfBG'
          : 'ViewRatesjumbotronFullBG'
      }`}
    >
      {renderImage()}
    </div>
  );
};
